import type { GroupStatus } from "@/api-types";

/**
 * Converts a GroupStatus enum value to a human-readable display string
 */
export function getGroupStatusDisplayText(status: GroupStatus): string {
  switch (status) {
    case "OPEN":
      return "Open for everyone";
    case "OPEN_VIA_LINK":
      return "Open via link";
    case "LOCKED":
      return "Closed";
    case "INACTIVE":
      return "Inactive";
    default:
      return status;
  }
}

/**
 * Gets the appropriate color for a group status badge
 */
export function getGroupStatusColor(status: GroupStatus): string {
  switch (status) {
    case "OPEN":
    case "OPEN_VIA_LINK":
      return "green";
    case "LOCKED":
      return "orange";
    case "INACTIVE":
      return "gray";
    default:
      return "gray";
  }
}
